<template>
  <VSection label="autotopupregistrations.registration_headline">
    <VDescriptionListDividedHorizontal>
      <VEntry :data="registrationDetails" field="id" name="autotopupregistrations.registration_autotopup_id_label" />
      <VEntry :value="$to(`autotopupregistrations.status_${registrationDetails.status}`)" name="autotopupregistrations.registration_status_label" />
      <VEntryDate :data="registrationDetails" field="creationDatetime" :name="registrationDatetimeLabel" />
      <VEntry :value="$t(`autotopupregistrations.created_by_${registrationDetails.createdBy}`)" :name="registrationByLabel" mandatory />
      <VEntryNumber :data="registrationDetails" field="amount" currency-field="amountUnits" name="autotopupregistrations.registration_amount_label" />
      <VEntry :data="registrationDetails" field="hasMrcFail" mandatory boolean name="autotopupregistrations.registration_has_mrcfail_label" />
      <VEntry :data="registrationDetails" :value="hasThresholdText" mandatory name="autotopupregistrations.registration_has_threshold_label" />
      <VEntry :data="registrationDetails" :value="hasDayOfMonthText" mandatory name="autotopupregistrations.registration_has_monthly_label" />
      <VEntry :data="registrationDetails" :value="paymentMethod" name="autotopupregistrations.registration_payment_method_label" />
      <VEntry :data="registrationDetails" field="correspondence" name="autotopupregistrations.registration_correspondence_email_label" />
      <VEntry :data="registrationDetails" field="channelName" name="autotopupregistrations.registration_topup_channel_label" />
    </VDescriptionListDividedHorizontal>
  </VSection>
</template>

<script>
import VSection from '@/components/Section';
import VDescriptionListDividedHorizontal from '@/components/DescriptionList/DividedHorizontal';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryDate from '@/components/DescriptionList/EntryDate';
import VEntryNumber from '@/components/DescriptionList/EntryNumber';
import formatCurrency from '@/mixins/formatCurrency';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
import { de, enUS } from 'date-fns/locale';

export default {
  name: 'AutoTopUpRegistrationDetailsRegistration',

  components: {
    VSection,
    VDescriptionListDividedHorizontal,
    VEntry,
    VEntryDate,
    VEntryNumber,
  },

  mixins: [formatCurrency],

  props: {
    registrationDetails: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasThresholdText() {
      if (this.registrationDetails.hasThreshold) {
        const formattedThresholdValue = this.formatCurrency(this.registrationDetails.threshold, this.registrationDetails.amountUnits);
        return this.$t('autotopupregistrations.registration_has_threshold_text', { formattedThresholdValue });
      } else {
        return this.$t('common.no');
      }
    },

    hasDayOfMonthText() {
      if (this.registrationDetails.hasMonthly) {
        let optionalNextTopUpDateText = '';
        if (this.registrationDetails.nextTopUp) {
          const date = parseISO(this.registrationDetails.nextTopUp);
          const nextTopUp = format(date, this.$t('common.dateFormat'));
          optionalNextTopUpDateText = this.$t('autotopupregistrations.registration_has_monthly_optional_next_topup_text', { nextTopUp });
        }

        // the month of the referenceDate has to support 31 days, otherwise the calculation might fail
        const referenceDateForDayOfMonthWithArbitraryYearAndMonth = new Date(1970, 1, this.registrationDetails.dayOfMonth);
        // 'do' format calculates the 'day of month' string representation (1st, 2nd, 3rd, xth) @see https://date-fns.org/v2.29.2/docs/format
        const dayOfMonth = format(referenceDateForDayOfMonthWithArbitraryYearAndMonth, 'do', { locale: this.$i18n.locale === 'de' ? de : enUS });
        return this.$t('autotopupregistrations.registration_has_monthly_text', { dayOfMonth }).concat(optionalNextTopUpDateText);
      } else {
        return this.$t('common.no');
      }
    },

    paymentMethod() {
      const key = `autotopupregistrations.registration_payment_method_${this.registrationDetails.paymentMethod}`;
      return this.$te(key) ? this.$t(key) : this.$t('autotopupregistrations.registration_payment_method_unknownPaymentMethodType');
    },

    registrationDatetimeLabel() {
      return this.registrationDetails.status === 'FAILED'
        ? 'autotopupregistrations.registration_failed_datetime_label'
        : 'autotopupregistrations.registration_creation_datetime_label';
    },

    registrationByLabel() {
      return this.registrationDetails.status === 'FAILED'
        ? 'autotopupregistrations.registration_failed_by_label'
        : 'autotopupregistrations.registration_created_by_label';
    },
  },
};
</script>
